module.exports = __webpack_public_path__ + "img/nature-30.415e236f.jpg";